<!-- agenda-especialista.component.html -->
<div class="p-3">
    <!-- Botón para mostrar horarios -->
    <div *ngIf="!horariosVisible" class="text-center">
      <button class="btn btn-outline-primary btn-sm" (click)="mostrarHorarios()">
        Ver horarios disponibles
      </button>
    </div>
  
    <!-- Contenido de horarios -->
    <div *ngIf="horariosVisible">
      <!-- Horarios una vez cargados -->
      <div>
        <!-- Días de la semana con navegación -->
        <div class="d-flex align-items-center mb-3">
          <button
            *ngIf="puedeRetroceder"
            class="btn btn-outline-secondary btn-sm me-2"
            (click)="navegarDia(-1)"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
  
          <div class="row flex-grow-1">
            <div
              class="col-4 text-center"
              *ngFor="let dia of diasMostrados; let i = index"
            >
              <div
                class="border rounded p-2"
                [class.bg-primary]="diaSeleccionado?.getTime() === dia.getTime()"
                [class.text-white]="diaSeleccionado?.getTime() === dia.getTime()"
                style="cursor: pointer"
                (click)="seleccionarDia(dia)"
              >
                <small class="d-block">{{ formatearFecha(dia, i) }}</small>
              </div>
            </div>
          </div>
  
          <button
            class="btn btn-outline-secondary btn-sm ms-2"
            (click)="navegarDia(1)"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
        <!-- Spinner mientras carga -->
        <div *ngIf="cargando" class="text-center py-3">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <small class="d-block mt-2">Cargando horarios...</small>
        </div>
        <!-- Horarios disponibles -->
        <div class="row" *ngIf="!cargando">
          <div class="col-12">
            <h6 class="mb-2">{{ tituloHorarios }}</h6>
  
            <div
              *ngIf="horarios.length > 0; else noHorarios"
              class="d-flex flex-wrap gap-2"
            >
              <button
                *ngFor="let horario of horarios"
                class="btn btn-outline-primary btn-sm"
                (click)="agendarCita(horario)"
              >
                {{ formatearHora(horario.hora) }}
                <br />
                <small>{{ horario.sede }}</small>
              </button>
            </div>
  
            <ng-template #noHorarios>
              <p class="text-muted">
                No hay horarios disponibles para esta fecha
              </p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
</div>

<!-- Modal de confirmación -->
<ng-template #confirmModal let-modal>
    <div #modalContainer class="">
      <div class="modal-header">
        <h5 class="modal-title" id="modal-title">
          <i class="dripicons-user-id"></i> {{ datosEspecialista.nombre }}
        </h5>
        <button
          type="button"
          class="btn-close"
          (click)="modal.dismiss('Cross click')"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formData" (ngSubmit)="confirmarCita()">
          <div class="row">
            <div class="col-md-12">
              <p class="text-muted font-size-13 mb-1">
                <span>
                  <i class="dripicons-user"></i> <strong> Paciente: </strong>
                  {{ datosConfirmar.paciente }}
                </span>
              </p>
              <p class="text-muted font-size-13 mb-1">
                <span>
                  <i class="dripicons-alarm"></i><strong> Hora: </strong>
                  {{ datosConfirmar.fechaCita }}
                </span>
              </p>
              <p class="text-muted font-size-13 mb-1">
                <span>
                  <i class="dripicons-location"></i> <strong> Sede: </strong>
                  {{ datosConfirmar.nombresede }}
                </span>
                <span> - {{ datosConfirmar.direccionSede }}</span>
                <span class="ms-1">
                  <strong>Consultorio: </strong>
                  {{ datosConfirmar.consultorio }}
                </span>
              </p>
              <hr />
              <div class="row">
                <div class="col-md-6">
                  <p class="text-muted font-size-13 mb-1">
                    <span>
                      <p class="text-muted font-size-13 mb-1">
                        <span><strong>Modalidad:</strong></span>
                      </p>
                      <div>
                        <div *ngIf="datosConfirmar.idSede != 'online'" class="">
                          <input
                            class="form-check-input m-1"
                            type="radio"
                            (change)="changeModalidad($event)"
                            formControlName="modalidad"
                            name="modalidad"
                            value="Presencial"
                            id="modalidad1"
                            checked
                          />
                          <label class="form-check-label" for="formRadios1">
                            Presencial</label
                          >
                        </div>
                        <div *ngIf="datosConfirmar.idSede == 'online'" class="">
                          <input
                            class="form-check-input m-1"
                            type="radio"
                            (change)="changeModalidad($event)"
                            formControlName="modalidad"
                            name="modalidad"
                            value="Online"
                            id="formRadios2"
                          />
                          <label class="form-check-label" for="formRadios2"
                            >Online</label
                          >
                        </div>
                      </div>
                    </span>
                  </p>
                </div>
                <input
                  class="form-control m-1"
                  type="text"
                  readonly
                  formControlName="duracion"
                  name="modalidad"
                  style="display: none"
                />
                <!-- <div class="col-md-6 text-end">
                                  <p class="text-muted font-size-13 mb-1"><span>
                                  <p class="text-muted font-size-13 mb-1"><span><strong>Duración: </strong></span></p>
                                  <p>{{duracion}} Minutos</p>
                                  <input class="form-control m-1" type="text" readonly formControlName="duracion" name="modalidad" style="display:none">
                                  </span>
                                  </p>
                              </div> -->
                <div class="col-md-12">
                  <p class="text-muted font-size-13 mb-1">
                    <span><strong>Servicio: </strong></span>
                  </p>
  
                  <ng-select
                    [items]="servicios"
                    bindValue="$id"
                    bindLabel="servicio"
                    placeholder="Seleccione"
                    appendTo="body"
                    [multiple]="false"
                    formControlName="servicio"
                    class="mb-2"
                    (change)="changeServicio($event)"
                    [ngClass]="{
                      'is-invalid': submitted && form.servicio.errors,
                      'is-valid': submitted && form.servicio.valid
                    }"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.servicio }} | {{ item.tConsulta?.tipo }}
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      <div style="margin: 5px 0" class="card">
                        <div class="card-body">
                          <h5 class="card-title">{{ item.servicio }}</h5>
                          <h6 class="card-subtitle mb-2 text-muted">
                            <small>Duración:</small> {{ item.duracion }} Min
                          </h6>
                          <h6 class="card-subtitle mb-2 text-muted">
                            <small>Modalidad:</small> {{ item.modalidad }}
                          </h6>
                        </div>
                      </div>
                    </ng-template>
                  </ng-select>
                  <div
                    *ngIf="submitted && form.servicio.errors"
                    class="invalid-feedback"
                  >
                    <span *ngIf="form.servicio.errors.required"
                      >Este campo es obligatorio</span
                    >
                  </div>
                </div>
  
                <div class="col-md-12" *ngIf="datosPaciente.idConvenio">
                  <div class="card" style="margin: 5px 0">
                    <div class="card-body">
                      <h5 class="card-title">
                        {{ datosPaciente.idConvenio.nombreConvenio }}
                      </h5>
                      <h6 class="card-subtitle mb-2 text-muted">
                        <small>Descuento:</small>
                        {{ datosPaciente.idConvenio.descuento }} %
                      </h6>
                      <div
                        class="card-text text-danger"
                        *ngIf="datosPaciente.idConvenio.requiereAprobacion"
                      >
                        SI Requiere aprobación
                      </div>
                      <div
                        class="card-text text-success"
                        *ngIf="!datosPaciente.idConvenio.requiereAprobacion"
                      >
                        AUTORIZADO
                      </div>
                      <small>Finaliza: </small
                      >{{
                        datosPaciente.idConvenio.fFinalizacionConvenio
                          | date : "dd/MM/yyyy"
                      }}
                      <hr />
                      <p class="text-muted font-size-13 mb-1">
                        <span>
                          <strong>Aplicar convenio: </strong>
                        </span>
                      </p>
  
                      <div class="d-flex">
                        <div>
                          <input
                            class="form-check-input m-1"
                            type="radio"
                            formControlName="convenio"
                            name="convenio"
                            value="NO"
                            id="noConvenio"
                            (change)="selectConvenio($event)"
                          />
                          <label class="form-check-label" for="noConvenio"
                            >No</label
                          >
                        </div>
                        <div>
                          <input
                            class="form-check-input m-1"
                            type="radio"
                            formControlName="convenio"
                            name="convenio"
                            value="SI"
                            id="siConvenio"
                            (change)="selectConvenio($event)"
                          />
                          <label class="form-check-label" for="siConvenio"
                            >Si</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="text-muted font-size-13 mb-1">
                <span>
                  <p class="text-muted font-size-13 mb-1">
                    <span><strong>Detalle / Motivo de consulta:</strong></span>
                  </p>
                  <textarea
                    class="form-control"
                    id="commentmessage-input"
                    rows="3"
                    formControlName="detalle"
                  ></textarea>
                  <div scope="row" colspan="2" class="border-0 text-end">
                    Total
                  </div>
                  <div class="border-0 text-end">
                    <h4 class="m-0">${{ valorTotal }}</h4>
                  </div>
                </span>
              </p>
  
              <div class="text-end mt-2">
                <button
                  type="button"
                  class="btn btn-light me-1"
                  (click)="modal.dismiss('Cross click')"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  id="btn-save-event"
                  (click)="confirmarCita()"
                >
                  Agendar Cita
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- end modal dialog-->
    </div>
</ng-template>